import React, { Component } from 'react';

import { USER_ROLE_ADMIN } from 'common/userRoles';

import { SCREEN_ID_ADMIN_ORDERS_OVERVIEW } from 'client/constants/screenIds';
import branch from 'client/core/branch';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withScreenId from 'client/helpers/withScreenId';
import allowedRoles from 'client/helpers/allowedRoles';

import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';
import SrSunSetupOrdersOverview from 'client/components/SrSunSetupOrdersOverview/SrSunSetupOrdersOverview';
import DriverActions from 'client/actions/Driver';
import SrButton, {
  SR_BUTTON_FONT_SIZE_SMALL,
  SR_BUTTON_HEIGHT_SHORTER,
  SR_BUTTON_THEME_ADOBE_GREEN,
} from 'client/components/SrButton/SrButton';

@withTransitionHook
@allowedRoles({
  roles: [USER_ROLE_ADMIN],
  redirectUrl: '/login',
  addRedirectQueryParam: true,
})
@withScreenId(SCREEN_ID_ADMIN_ORDERS_OVERVIEW)
@branch({
  driversByMarketId: ['drivers', 'byMarketId'],
})
@withScrollToTop
class AdminOrdersOverviewPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Setup Orders',
    section: 'Admin',
  });

  static fetchData(state, inject) {
    const currentUser = inject.state.get(['currentUser']);
    const isAdmin = currentUser.roles.includes(USER_ROLE_ADMIN);
    const promisesToResolve = [];
    if (isAdmin) {
      promisesToResolve.push(DriverActions.getDriverList(inject));
    }
    return Promise.all(promisesToResolve);
  }

  render() {
    const { driversByMarketId, history } = this.props;

    const backUrl = history.location.pathname;
    const sunsetupUrl = `/sunsetup/orders/create?backUrl=${backUrl}`;

    return (
      <SrPartnerPageV2
        navbarTitle="SunSetup"
        navBarActionButton={
          <SrButton
            theme={SR_BUTTON_THEME_ADOBE_GREEN}
            heightType={SR_BUTTON_HEIGHT_SHORTER}
            fontSizeType={SR_BUTTON_FONT_SIZE_SMALL}
            onClick={() => history.push(sunsetupUrl)}
          >
            Create Order
          </SrButton>
        }
      >
        <SrSunSetupOrdersOverview driversByMarketId={driversByMarketId} />
      </SrPartnerPageV2>
    );
  }
}

AdminOrdersOverviewPage.displayName = 'AdminOrdersOverviewPage';

export default AdminOrdersOverviewPage;
